import { useMemo } from 'react';
import { useCommunities } from 'containers/Api2/index.js';
import { idValues } from 'utils/arrays.js';

function useStudentColor() {
  const communities = useCommunities();
  const communitiesList = useMemo(() => idValues(communities), [communities]);
  return (student) => {
    const community = communitiesList.find((comm) => comm.name === student.groups[0]) || communitiesList[0];
    if (!community) {
      return '#ccc';
    }
    return community.theme.themeColor.hex;
  };
}

export default useStudentColor;
